'use client';
import type { ReactNode } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { useRouter } from 'solito/navigation';
import { useRevokeWebAppSession } from '@cxnpl/api/users/users';
import { shutdown as intercomShutdown } from '@intercom/messenger-js-sdk';
import { useAppDispatch } from '../../store';
import { setInactivityLogout } from '../../features/auth/authSlice';

export interface InactivityTimeoutProviderProps {
  timeout: number;
  children: ReactNode;
}

export function InactivityTimeoutProvider({ timeout, children }: InactivityTimeoutProviderProps) {
  const router = useRouter();
  const logoutUser = useRevokeWebAppSession();
  const dispatch = useAppDispatch();

  const onIdle = () => {
    intercomShutdown();
    logoutUser
      .mutateAsync({ data: { appClient: 'WEB' } })
      .catch(() => {
        // TODO: should this show an error anywhere?
      })
      .finally(() => {
        dispatch(setInactivityLogout(true));
        router.push('/login');
      });
  };

  return (
    <IdleTimerProvider timeout={timeout} onIdle={onIdle} startOnMount stopOnIdle>
      {children}
    </IdleTimerProvider>
  );
}
